import { SVGProps } from 'react'

const DiscordIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.33 2.506A19.849 19.849 0 0 0 15.38.982a13.61 13.61 0 0 0-.634 1.29 18.438 18.438 0 0 0-5.495 0c-.189-.44-.4-.871-.635-1.29A19.989 19.989 0 0 0 3.66 2.51C.527 7.146-.323 11.667.102 16.123a19.959 19.959 0 0 0 6.073 3.05c.491-.662.926-1.364 1.3-2.098a12.915 12.915 0 0 1-2.048-.978c.172-.125.34-.253.502-.378a14.264 14.264 0 0 0 12.142 0c.164.135.332.263.502.378-.654.386-1.34.714-2.052.98.373.734.808 1.435 1.3 2.095a19.869 19.869 0 0 0 6.077-3.047c.498-5.168-.851-9.648-3.568-13.62ZM8.013 13.383c-1.183 0-2.161-1.074-2.161-2.396 0-1.321.944-2.405 2.157-2.405 1.214 0 2.184 1.084 2.164 2.405-.021 1.322-.954 2.396-2.16 2.396Zm7.974 0c-1.186 0-2.16-1.074-2.16-2.396 0-1.321.944-2.405 2.16-2.405 1.215 0 2.178 1.084 2.157 2.405-.02 1.322-.951 2.396-2.157 2.396Z"
    />
  </svg>
)
export default DiscordIcon
